// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { LiquidacaoResto } from './liquidacao-resto.model';

export class LiquidacaoRestoDeducaoReinf extends BaseResourceModel {
    constructor(
        public id?: number,
        public tipo?: number,
        public valor_deducao?: number,
        public previdencia_complementar?: boolean,
        public cnpj_previdencia_complementar?: string,
        public valor_patrocinador?: number,
        public liquidacao_resto?: LiquidacaoResto
    ) {
        super();
    }

    static converteJson(json: any): LiquidacaoRestoDeducaoReinf {
        return Object.assign(new LiquidacaoRestoDeducaoReinf(), json);
    }
}
